import React from 'react';
import PropTypes from 'prop-types';

/**
 * 그레이 원형 'i' 안내 아이콘.
 * 툴팁/안내 모달을 여는 버튼 등에서 공통으로 사용합니다.
 */
export default function IconInfoCircleGray({className = ''}) {
    return (
        <svg
            className={className}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-hidden="true"
        >
            <path d="M17.0833 10C17.0833 6.08798 13.912 2.91667 10 2.91667C6.08798 2.91667 2.91667 6.08798 2.91667 10C2.91667 13.912 6.08798 17.0833 10 17.0833C13.912 17.0833 17.0833 13.912 17.0833 10ZM18.75 10C18.75 14.8325 14.8325 18.75 10 18.75C5.16751 18.75 1.25 14.8325 1.25 10C1.25 5.16751 5.16751 1.25 10 1.25C14.8325 1.25 18.75 5.16751 18.75 10Z"
                  fill="#B2B2B2"/>
            <path d="M10.2832 7.7832C10.5915 7.7832 10.8413 8.03324 10.8415 8.34147V13.3415H11.6626C12.0468 13.3415 12.3583 13.6531 12.3584 14.0373C12.3584 14.4215 12.0469 14.733 11.6626 14.7331H8.61247C8.22818 14.7331 7.91667 14.4216 7.91667 14.0373C7.91679 13.6531 8.22826 13.3415 8.61247 13.3415H9.44987V9.1748H8.61247C8.22818 9.17479 7.91667 8.86329 7.91667 8.479C7.91679 8.09482 8.22826 7.78322 8.61247 7.7832H10.2832Z"
                  fill="#B2B2B2"/>
            <path d="M11.1083 5.42077C11.1083 6.03518 10.6102 6.53327 9.99581 6.53327C9.38139 6.53327 8.88331 6.03518 8.88331 5.42077C8.88331 4.80635 9.38139 4.30827 9.99581 4.30827C10.6102 4.30827 11.1083 4.80635 11.1083 5.42077Z"
                  fill="#B2B2B2"/>
        </svg>
    );
}

IconInfoCircleGray.propTypes = {
    className: PropTypes.string,
};
